import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { RequisitoGarantiaCantidadTipoVinculacion } from '../_models/requisito-garantia-cantidad-tipo-vinculacion';

@Injectable({
  providedIn: 'root'
})
export class RequisitoGarantiaCantidadTipoVinculacionService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/requisitosGarantiasCantidadesTiposVinculaciones';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as RequisitoGarantiaCantidadTipoVinculacion[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as RequisitoGarantiaCantidadTipoVinculacion[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as RequisitoGarantiaCantidadTipoVinculacion ) );
  }

  listadoPorIdRequisito( id: string ) {
    return this.httClient.get( this.rutServicio + '/requisitoGarantia/' + id ).pipe( map( res => res as RequisitoGarantiaCantidadTipoVinculacion[] ) );
  }

  listadoPorIdRequisitoHabilitado( id: string ) {
    return this.httClient.get( this.rutServicio + '/requisitoGarantia/' + id + '/enabled' ).pipe( map( res => res as RequisitoGarantiaCantidadTipoVinculacion[] ) );
  }

  crear( regCrear: RequisitoGarantiaCantidadTipoVinculacion ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as RequisitoGarantiaCantidadTipoVinculacion ) );
  }

  bulk( regCrear: RequisitoGarantiaCantidadTipoVinculacion[] ) {
    const auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    regCrear.map( x => {
      x.auditoriaUsuario = auditoriaUsuario;
    } );
    return this.httClient.post( this.rutServicio + '/bulk', regCrear ).pipe( map( res => res as RequisitoGarantiaCantidadTipoVinculacion ) );
  }

  actualizar( regActualizar: RequisitoGarantiaCantidadTipoVinculacion ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as RequisitoGarantiaCantidadTipoVinculacion ) );
  }
}
